<template>
  <div>
    <print-table v-show="activeKey===1" ref="list" @config="config"/>
    <print-config v-show="activeKey===2" ref="configs" @back="back"/>
  </div>
</template>

<script>
import PrintTable from '@/views/config/print/PrintTable.vue'
import PrintConfig from '@/views/config/print/PrintConfig.vue'

export default {
  name: 'Print',
  components: { PrintTable, PrintConfig },
  data() {
    return {
      activeKey: 1
    }
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    config(print) {
      this.activeKey = 2
      this.$refs.configs.refresh(print)
    }
  }
}
</script>